import React from "react";
import { SOCIALS } from "@/lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ink-950 pt-24 pb-12 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-12 gap-8 mb-16">
        <div className="col-span-12 md:col-span-5">
          <div className="text-xs tracking-[0.4em] uppercase text-cyan-glow mb-4">◢ Contact</div>
          <div className="font-display font-bold text-2xl md:text-3xl tracking-tight">
            management@cassiusgrate.com
          </div>
          <div className="text-sm text-slate-400 mt-2 font-light">
            Bookings · Press · Sync · Brand Partnerships
          </div>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="text-[10px] tracking-[0.4em] uppercase text-slate-500 mb-4">Listen</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#music" className="hover:text-gold">Spotify</a></li>
            <li><a href="#music" className="hover:text-gold">Apple Music</a></li>
            <li><a href="#music" className="hover:text-gold">YouTube</a></li>
            <li><a href="#music" className="hover:text-gold">SoundCloud</a></li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-2">
          <div className="text-[10px] tracking-[0.4em] uppercase text-slate-500 mb-4">Follow</div>
          <ul className="space-y-2 text-sm">
            {SOCIALS.map((s) => (
              <li key={s.name}>
                <a href={s.url} className="hover:text-gold">{s.name}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-span-12 md:col-span-2">
          <div className="text-[10px] tracking-[0.4em] uppercase text-slate-500 mb-4">Legal</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="#" className="hover:text-white">Privacy</a></li>
            <li><a href="#" className="hover:text-white">Terms</a></li>
            <li><a href="#" className="hover:text-white">Returns</a></li>
          </ul>
        </div>
      </div>

      <div className="horizon-divider mb-10" />

      <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
        <div className="text-xs text-slate-500 font-mono">
          © {new Date().getFullYear()} CASSIUS GRATE · ALL TIDES RESERVED
        </div>
        <div className="font-serif italic text-slate-500 text-sm">
          "The tsunami doesn't ask. It arrives."
        </div>
      </div>
    </div>

    <div className="pointer-events-none mt-20 -mb-16 md:-mb-28 overflow-hidden">
      <div className="font-display font-black uppercase tracking-tighter leading-none text-outline-gold text-center text-[20vw] opacity-20 whitespace-nowrap">
        TSUNAMI
      </div>
    </div>
  </footer>
);
